import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';

export abstract class AbstractEtsyIntegrationVersionService {
  abstract initiateConnection(): Observable<string>;
  abstract connect(params: Params): Observable<EStore>;
}
